export function addQueryParamsToUrl({
  url,
  includeUtmCampaign = true,
  variation = "about_page",
  extraQueryParams = {},
  pageType = "about_page",
  organicUrl,
}: {
  url: string;
  includeUtmCampaign?: boolean;
  variation?: string;
  extraQueryParams?: Record<string, string | number | boolean>;
  pageType?: string;
  organicUrl: string | null | undefined;
}): string {
  const isServer = typeof window === "undefined";
  const urlWithUpdatedParams = new URL(url);
  const { searchParams } = urlWithUpdatedParams;
  const currentUrlParams = isServer ? null : window.location.search;

  searchParams.set("utm_source", "edx");
  searchParams.set("utm_medium", "referral");
  searchParams.set("variation", encodeURIComponent(variation));
  searchParams.set("page_type", pageType);

  if (includeUtmCampaign && organicUrl) {
    const { searchParams: externalParams } = new URL(organicUrl);
    searchParams.set("utm_campaign", externalParams.get("utm_campaign") || "");
  }

  const currentParams = currentUrlParams
    ? new URLSearchParams(currentUrlParams)
    : null;

  if (currentParams) {
    const linkedFrom = currentParams.get("linked_from");
    if (linkedFrom) {
      searchParams.set("linked_from", linkedFrom);
    }

    const searchTerm = currentParams.get("search_term");
    if (searchTerm) {
      searchParams.set("edxSearch", searchTerm);
    }

    Array.from(currentParams.entries())
      .filter(([key]) => key.startsWith("filtered_"))
      .forEach(([key, value]) => {
        searchParams.set(key, value);
      });
  }

  Object.entries(extraQueryParams).forEach(([key, value]) => {
    searchParams.set(key, String(value));
  });

  return urlWithUpdatedParams.toString();
}
